import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Tag, TagCloseButton, TagLabel } from '@/ui';

type Props = {
  id: string;
  text: string;
  bg: string;
  borderColor: string;
  onRemove: (id: string) => void;
};

export const SortableLabelTag = ({
  id,
  text,
  bg,
  borderColor,
  onRemove,
}: Props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  return (
    <Tag
      bg={bg}
      border="1px solid"
      borderColor={borderColor}
      borderRadius="ah-pill"
      color="ink.strong"
      cursor="grab"
      fontSize="ah-control"
      fontWeight={600}
      gap={1.5}
      opacity={isDragging ? 0.6 : 1}
      position="relative"
      px={3}
      py={1.5}
      ref={setNodeRef}
      size="md"
      sx={{ touchAction: 'none' }}
      zIndex={isDragging ? 1 : undefined}
      style={{
        // Translate only — never scale — so variable-width pills keep their
        // natural size instead of stretching to the drop slot's width.
        transform: CSS.Translate.toString(transform),
        transition,
      }}
      {...attributes}
      {...listeners}
    >
      <TagLabel>{text}</TagLabel>
      {/* Stop pointer- and key-down so activating the close button (mouse or
          keyboard) removes the label instead of starting a drag. */}
      <TagCloseButton
        aria-label={`Remove ${text}`}
        onClick={() => onRemove(id)}
        onKeyDown={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
      />
    </Tag>
  );
};
